module.exports = __webpack_public_path__ + "img/67.3.TP.5c23a496.png";